import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, description, showBack = true }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 4 }}>
      {/* {showBack && (
        <Typography
          sx={{ cursor: "pointer", mb: 2, fontWeight: 500 }}
          onClick={() => navigate(-1)}
        >
          ← Back
        </Typography>
      )} */}

      <Typography variant="h4" fontWeight={700} mb={1}>
        {title}
      </Typography>

      {/* <Typography color="text.secondary">
        {description}
      </Typography> */}
    </Box>
  );
};

export default PageHeader;
